import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i4.28
import React from 'react';
import IconWrap from '../../IconWrap';
const SubmitPostStatus = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M15.506 3.25a.493.493 0 01.68-.182l.862.505c.239.14.321.447.184.687l-.77 1.351a.493.493 0 01-.679.182l-.863-.504a.507.507 0 01-.184-.687l.77-1.352zM5.861 16.87l-1.414 2.258L2 14.834l2.637-.11 6.626-10.586c.2-.32.666-.313.852.014l6.522 11.443a.505.505 0 01-.414.755l-12.362.52zM21.18 5.834a.493.493 0 00-.68-.182l-3.476 2.034a.507.507 0 00-.184.687l.507.89c.137.24.44.321.68.182l3.476-2.034a.507.507 0 00.184-.687l-.507-.89zm.32 4.984a.5.5 0 01.5.5v1.03a.5.5 0 01-.5.5h-2.007a.5.5 0 01-.5-.5v-1.03a.5.5 0 01.5-.5H21.5zM11.848 21c-1.66.06-3.052-1.256-3.11-2.937l1.502-.053c.03.84.726 1.498 1.555 1.468a1.515 1.515 0 001.45-1.576l1.503-.053c.058 1.681-1.24 3.092-2.9 3.151z",
        clipRule: "evenodd"
    })));
SubmitPostStatus.displayName = 'SubmitPostStatus';
export default SubmitPostStatus;
